module.exports = __webpack_public_path__ + "assets/img/light-23613980.png";